import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Plus } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { CurrencyTotals } from "@/components/finance/CurrencyTotals";
import { FieldsForm } from "@/components/finance/FieldsForm";

export const ListPanel = ({ endpoint, detailPath, fields, totalRows, createLabel, createTestid, Card, testid }) => {
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [creating, setCreating] = useState(false);
  const load = useCallback(() => api.get(endpoint).then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e))), [endpoint]);
  useEffect(() => { load(); }, [load]);

  const create = async (payload) => {
    try {
      const { data: created } = await api.post(endpoint, payload);
      setCreating(false);
      toast.success("Registro creado");
      nav(`${detailPath}/${created.id}`);
    } catch (e) { toast.error(errMsg(e)); }
  };

  if (!data) return <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin c-muted" /></div>;
  return (
    <div data-testid={testid} className="space-y-4">
      <CurrencyTotals totals={data.totals} rows={totalRows} />
      <div className="flex items-center justify-between">
        <p data-testid={`${testid}-count`} className="text-sm c-text-2">{data.items.length} registro(s)</p>
        <button data-testid={createTestid} onClick={() => setCreating(true)} className="c-btn-primary px-3.5 py-2 text-sm flex items-center gap-1.5">
          <Plus className="w-4 h-4" /> {createLabel}
        </button>
      </div>
      <div className="space-y-2.5">
        {data.items.map((it) => <Card key={it.id} item={it} onClick={() => nav(`${detailPath}/${it.id}`)} />)}
      </div>
      <FieldsForm open={creating} onOpenChange={setCreating} title={createLabel} fields={fields} item={null} onSubmit={create} testid="create-form-sheet" />
    </div>
  );
};
